import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { LogoControl, ScreenContainerControl } from "doshx_controls_web";
import { useFooterState } from "./hooks/use-footer-state";
import logo from "../../assets/scee_logo.png";
import Visa from "../../assets/banking/visa_logo.png";
import Mastercard from "../../assets/banking/mastercard_logo.png";
import Amex from "../../assets/banking/amex_logo.png";
import Paypal from "../../assets/banking/paypal_logo.png";
const LOGOS = [
    {
        label: "Mastercard",
        image: Mastercard,
    },
    {
        label: "Paypal",
        image: Paypal,
    },
    {
        label: "American Express",
        image: Amex,
    },
    {
        label: "Visa",
        image: Visa,
    },
];
export function Footer({ onNewsletterSubmitted }) {
    const { errors, handleSocialClicked, handleSubmitNewsletter, register, shopLinks, socials, supportLinks, companyLinks } = useFooterState();
    const navigate = useNavigate();
    const currentYear = new Date().getFullYear();
    return (React.createElement("div", null,
        React.createElement("div", { className: "w-full flex flex-col lg:flex-row justify-start items-start gap-4 bg-secondary border-y border-y-light-gray px-8 py-16" },
            React.createElement("div", { className: "flex flex-col gap-2 w-full items-center lg:items-start lg:w-[20%] order-3 lg:order-1 pt-10 lg:pt-0" },
                React.createElement("div", null,
                    React.createElement(LogoControl, { image: logo, size: "large", onClick: () => navigate("/") })),
                React.createElement("div", { className: "flex gap-6 w-full justify-center lg:justify-start mt-4" }, socials?.map(({ identifier, image, url }) => (React.createElement("button", { key: identifier, onClick: handleSocialClicked(url) },
                    React.createElement("div", { className: "flex justify-center" }, image)))))),
            React.createElement("div", { className: "flex flex-row gap-2 w-full lg:w-[50%] order-2 lg:order-2 pt-10 lg:pt-0" },
                React.createElement("div", { className: "flex flex-col gap-4 w-full" },
                    React.createElement("div", { className: "text-dark-gray" }, "Shop"),
                    shopLinks?.map(({ identifier, url, label }) => (React.createElement(Link, { key: identifier, to: url },
                        React.createElement("div", { key: identifier }, label))))),
                React.createElement("div", { className: "flex flex-col gap-4 w-full" },
                    React.createElement("div", { className: "text-dark-gray" }, "Company"),
                    companyLinks?.map(({ identifier, url, label }) => (React.createElement(Link, { key: identifier, to: url },
                        React.createElement("div", { key: identifier }, label))))),
                React.createElement("div", { className: "flex flex-col gap-4 text-nowrap w-full" },
                    React.createElement("div", { className: "text-dark-gray" }, "Support"),
                    supportLinks?.map(({ identifier, url, label }) => (React.createElement(Link, { key: identifier, to: url },
                        React.createElement("div", { key: identifier }, label)))))),
            React.createElement("div", { className: "flex flex-col gap-4 w-full lg:w-[30%] order-1 lg:order-3" },
                React.createElement("div", { className: "text-dark-gray" }, "Newsletter"),
                React.createElement("form", { className: "flex gap-4", onSubmit: handleSubmitNewsletter(onNewsletterSubmitted) },
                    React.createElement("div", { className: "flex flex-col gap-2 grow" },
                        React.createElement("input", { className: "rounded-xl border border-light-gray px-4 py-2 w-full", placeholder: "Your Email", ...register("email", {
                                pattern: {
                                    value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                                    message: "Please enter a valid email-address",
                                },
                                required: { value: true, message: "Your email-address is required to sign up" },
                            }) }),
                        errors?.["email"] && React.createElement("div", { className: "text-xs text-error" }, errors?.["email"]?.message?.toString() ?? null)),
                    React.createElement("button", { className: "max-h-[42px] flex justify-center rounded-xl bg-primary px-4", type: "submit" },
                        React.createElement("div", { className: "text-secondary my-auto" }, "Subscribe"))),
                React.createElement("div", { className: "text-sm text-dark-gray" }, "Subscribe to our newsletter for the latest updates"))),
        React.createElement("div", { className: `flex flex-col items-center gap-y-4 py-3` },
            React.createElement(ScreenContainerControl, { className: "flex flex-row items-center justify-start py-2 px-8 xl:max-w-[100vw]" },
                React.createElement("div", { className: "flex flex-col md:flex-row w-full text-sm text-dark-gray" },
                    React.createElement("div", { className: "flex w-full md:w-[70%] justify-center md:justify-start p-2 md:p-0" },
                        "Southern Cross Educational Enterprises \u00A9 ",
                        currentYear),
                    React.createElement("div", { className: "flex w-full md:w-[30%] justify-center md:justify-start p-2 md:p-0" }, LOGOS.map(({ label, image }) => (React.createElement("img", { key: label, className: "h-6 mx-2 inline", src: image, alt: label })))))))));
}
